module.exports = __webpack_public_path__ + "static/media/talbot_room.39183740.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/talbot_room.png
 ** module id = 698
 ** module chunks = 0
 **/